module.exports = __webpack_public_path__ + "img/indu_5.2ec535e3.png";